import { render, staticRenderFns } from "./EditarInformacoes.vue?vue&type=template&id=bee11564"
import script from "./EditarInformacoes.vue?vue&type=script&lang=js"
export * from "./EditarInformacoes.vue?vue&type=script&lang=js"
import style0 from "./EditarInformacoes.vue?vue&type=style&index=0&id=bee11564&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports